import axiosClient from 'api/axiosClient';
import imgEmptyThanhToan from 'assets/images/img_emptyview_thanh_toan.png';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSButton, {
  KTBSButtonColor,
  KTBSButtonSize,
} from 'general/components/OtherKeenComponents/KTBSButton';
import KTPagination, {
  KTPaginationColor,
} from 'general/components/OtherKeenComponents/KTPagination';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import EmptyView from 'general/components/Others/EmptyView';
import AppRoute from 'general/constants/AppRoute';
import ToastHelper from 'general/helpers/ToastHelper';
import Utils from 'general/utils/Utils';
import useRouter from 'hooks/useRouter';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ViewAddEnergyBill from '../ViewAddEnergyBill';
import { useSelector } from 'react-redux';
import useConfigTableColumn from 'hooks/useConfigTableColumn';
import DropdownTableConfigColumn2 from 'general/components/DropdownTableConfigColumn2';
import AppConstants from 'general/constants/AppConstants';
import AppColors from 'general/constants/AppColors';
import DealerHelper from 'features/ManageDealer/dealerHelper';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import CustomDateRangePicker, { dateFilter } from 'general/components/Others/CustomDateRangePicker';
import UIHelper from 'general/helpers/UIHelper';

LandownerElectricityPaymentHistoryView.propTypes = {
  items: PropTypes.array,
  pagination: PropTypes.object,
  filter: PropTypes.object,
  onFilterChanged: PropTypes.func,
  showFullUI: PropTypes.bool,
};

const defaultColumnIds = ['STATION_CODE', 'STATION_NAME', 'CUSTOMER_CODE', 'CUSTOMER_NAME', 'INVOICE_SERIAL', 'INVOICE_SIGNATURE', 'ENERGY', 'ENERGY_START', 'ENERGY_END', 'AMOUNT', 'MONTH', 'STATUS'];

function LandownerElectricityPaymentHistoryView(props) {
  // MARK: ---- params ----
  const { items, pagination, filter, onFilterChanged, onDeleteItem, handleGetEnergyBillList, showFullUI = false } = props;
  const router = useRouter();
  const { t } = useTranslation();
  const agencyId = router.query?.landownerId;
  const { user } = useSelector((state) => state.auth);
  const fullColumns = useMemo(() => {
    return [
      {
        id: 'STATION_CODE',
        name: <span className="letter-spacing-unset font-weight-bolder"
          style={{
            fontSize: 12,
            color: AppColors.gray[900],
          }}
        >{t('Mã trạm sạc')}</span>,
        selector: (row) => row?.station?.stationCode,
        style: tableStyle.columns.link,
        minWidth: '120px',
      },
      {
        id: 'STATION_NAME',
        name: <span className="letter-spacing-unset font-weight-bolder"
          style={{
            fontSize: 12,
            color: AppColors.gray[900],
          }}
        >{t('Tên trạm sạc')}</span>,
        selector: (row) => {
          return (
            <KTTooltip
              offset={[0, 0]}
              text={row?.station?.name ?? 'N/A'}
            >
              <span
                onClick={() => {
                  router.navigate(`${AppRoute.stationList}/${row?.station?.stationId ?? ''}`)
                }}
              >{row?.station?.name ?? 'N/A'}</span>
            </KTTooltip>
          )
        },
        style: tableStyle.columns.link,
        minWidth: '300px',
      },
      {
        id: 'CUSTOMER_CODE',
        name: <span className="letter-spacing-unset font-weight-bolder"
          style={{
            fontSize: 12,
            color: AppColors.gray[900],
          }}
        >{t('Mã khách hàng tại EVN')}</span>,
        selector: (row) => row?.evnCustomerCode ?? row?.evnCustomerId,
        style: tableStyle.columns.normal,
        minWidth: '190px',
      },
      {
        id: 'CUSTOMER_NAME',
        name: <span className="letter-spacing-unset font-weight-bolder"
          style={{
            fontSize: 12,
            color: AppColors.gray[900],
          }}
        >{t('Tên khách hàng')}</span>,
        selector: (row) => row?.evnCustomerName,
        style: tableStyle.columns.normal,
        minWidth: '200px',
      },
      {
        id: 'MONTH',
        name: <span className="letter-spacing-unset font-weight-bolder"
          style={{
            fontSize: 12,
            color: AppColors.gray[900],
          }}
        >{t('Tháng')}</span>,
        selector: (row) => Utils.formatDateTimeToString(row?.month, 'MM/YYYY'),
        minWidth: '80px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'ENERGY',
        name: <span className="letter-spacing-unset font-weight-bolder"
          style={{
            fontSize: 12,
            color: AppColors.gray[900],
          }}
        >{t('Số điện đã dùng')}</span>,
        selector: (row) => Utils.formatNumber(row?.evnEnergyUsed ?? 0),
        minWidth: '140px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'ENERGY_START',
        name: <span className="letter-spacing-unset font-weight-bolder"
          style={{
            fontSize: 12,
            color: AppColors.gray[900],
          }}
        >{t('Số điện đầu tháng')}</span>,
        selector: (row) => Utils.formatNumber(row?.evnBeginingCycleCounter ?? 0),
        minWidth: '160px',
        style: tableStyle.columns.normal,
      },
      // {
      //   id: 'ENERGY_END',
      //   name: <span className="letter-spacing-unset font-weight-bolder"
      //     style={{
      //       fontSize: 12,
      //       color: AppColors.gray[900],
      //     }}
      //   >{t('Số điện cuối tháng')}</span>,
      //   selector: (row) => Utils.formatNumber(row?.evnEndingCycleCounter ?? 0),
      //   grow: 1,
      //   style: tableStyle.columns.normal,
      // },
      {
        id: 'INVOICE_SERIAL',
        name: <span className="letter-spacing-unset font-weight-bolder"
          style={{
            fontSize: 12,
            color: AppColors.gray[900],
          }}
        >{t('Serial biên lai')}</span>,
        selector: (row) => row?.evnInvoiceSerial,
        minWidth: '130px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'INVOICE_SIGNATURE',
        name: <span className="letter-spacing-unset font-weight-bolder"
          style={{
            fontSize: 12,
            color: AppColors.gray[900],
          }}
        >{t('Chữ ký biên lai')}</span>,
        selector: (row) => row?.evnInvoiceSignature,
        minWidth: '130px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'AMOUNT',
        name: <span className="letter-spacing-unset font-weight-bolder"
          style={{
            fontSize: 12,
            color: AppColors.gray[900],
          }}
        >{t('Số tiền')}</span>,
        selector: (row) => Utils.formatNumber(row?.amount ?? 0),
        style: tableStyle.columns.normal,
        minWidth: '100px',
      },
      ...(user?.role !== AppConstants.userRole.admin
        ? [
          {
            id: 'STATUS',
            name: <span className="letter-spacing-unset font-weight-bolder"
              style={{
                fontSize: 12,
                color: AppColors.gray[900],
              }}
            >{t('status')}</span>,
            minWidth: '120px',
            selector: (row) => (
              <KTLabel
                text={t(`energyBillStatus_${row.status}`)}
                isInline={true}
                size={KTLabelSize.medium}
                additionalClassName={`label-light-${DealerHelper.getLandownerElectricityBillColor(
                  row.status
                )}`}
              />
            ),
          },
        ]
        : []),
      ...(user?.role === AppConstants.userRole.admin
        ? [
          {
            name: <span className="letter-spacing-unset font-weight-bolder"
              style={{
                fontSize: 12,
                color: AppColors.gray[900],
              }}
            >{t('Xác nhận')}</span>,
            wrap: true,
            minWidth: '120px',
            style: {
              position: 'sticky',
              right: 0,
              backgroundColor: '#fff',
              borderLeft: '1px solid #ebedfe',
            },
            selector: (row) =>
              row?.status === 'PENDING' ? (
                <div className="d-flex gap-3">
                  <KTBSButton
                    size={KTBSButtonSize.small}
                    title="Xác nhận"
                    borderRadius={5}
                    bgColor={AppColors.primary}
                    buttonTitleFontWeight="600"
                    buttonTitleFontSize={13}
                    onPress={() => handleUpdateBillStatus(row?.billId, 'VALIDATED')}
                  />
                </div>
              ) : null,
          },
        ]
        : [])
    ];
  }, []);
  const [stationList, setStationList] = useState([]);

  const prefKey = useMemo(() => {
    const userId = user.userId;
    const pathName = `${router.pathname}${router.location.hash}`;
    const key = `${userId}_${pathName}`;
    return key;
  }, [user, router]);
  const [fullColumnIds, setFullColumnIds] = useState(
    fullColumns?.map((row) => row?.id).filter(Boolean) || []
  );
  const {
    columnIds,
    columns,
    onChangeCheckboxValue,
    resetDefaultTableColumn,
    onSelectAll,
    onUnSelectAll,
    fullColumnsSorted,
    fullColumnsIdSorted,
  } = useConfigTableColumn(
    prefKey,
    fullColumnIds,
    defaultColumnIds,
    fullColumns
  );

  // MARK: ---- methods ----
  useEffect(() => {
    const getChargeStationList = async () => {
      let filter = {
        landlordId: agencyId,
        page: 0,
        limit: 100,
      };
      const res = await axiosClient.get('/cs', { params: Utils.filterParams(filter) });
      const { result, chargeStations, total } = res;
      if (result === 'success') {
        setStationList(chargeStations);
      }
    };

    getChargeStationList();
  }, []);

  const agencyRoleList = useMemo(() => {
    const roles = user?.agency?.commissions?.map((commission) => commission.role) || [];
    return Array.from(new Set(roles));
  }, [user]);

  const handleAddEnergyBill = () => {
    AppCustomDialogHelper.show(
      'Khai báo tiền điện',
      <ViewAddEnergyBill
        stationList={stationList}
        onClosed={() => {
          AppCustomDialogHelper.hide();
        }}
        onSubmitted={async (values) => {
          try {
            const params = {
              ...values,
              role: AppConstants.userRole.agency,
              status: AppConstants.energyBillStatus.pending
            };

            const res = await axiosClient.post('/energyBill/create', params);
            const { result, energyBill, reason } = res;

            if (result === 'success') {
              ToastHelper.showSuccess('Thêm hoá đơn tiền điện thành công');
              AppCustomDialogHelper.hide();
              onFilterChanged(filter);
            } else {
              ToastHelper.showError(reason ?? 'Thêm hoá đơn tiền điện thất bại');
            }
          } catch (error) {
            ToastHelper.showError('Đã xảy ra lỗi khi thêm hoá đơn tiền điện: ' + error.message);
          }
        }}
      />,
      'lg',
      false
    );
  };

  const handleUpdateBillStatus = async (billId, status) => {
    const params = {
      status
    };
    const res = await axiosClient.put(`/energyBill/${billId}`, params);
    const { result, reason } = res;
    if (result === 'success') {
      ToastHelper.showSuccess('Xác nhận thành công');
      handleGetEnergyBillList();
    } else {
      ToastHelper.showError(reason ?? 'Xác nhận không thành công');
    }
  };

  return (
    <div>
      {showFullUI && (
        <div className="d-flex justify-content-between align-items-center">
          {/* title */}
          <div className="d-flex flex-column align-items-start">
            <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
              Lịch sử trả tiền điện
            </span>
            <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
              Tổng số:{' '}
              <span style={{ color: AppColors.primary }}>
                {Utils.formatNumber(pagination?.total)} hóa đơn
              </span>
            </span>
          </div>

          {/* actions */}
        </div>
      )}
      {/* header */}
      <div className="w-100 d-flex align-items-end flex-wrap">
        {/* tim kiem */}
        <div className="col-lg-3 col-sm-6 px-0 pr-sm-4 py-2">
          <label htmlFor="search-bar" className="mb-0 mr-2 font-weight-bolder">
            {t('search')}
          </label>
          <KTFormSearch
            name="search-bar"
            placeholder={t('Nhập để tìm kiếm...')}
            value={filter.q}
            onSubmit={(text) => {
              if (onFilterChanged) onFilterChanged({ q: text });
            }}
          />
        </div>

        <div className="col-lg-3 col-sm-6 px-0 pr-lg-4 py-2">
          <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
            {t('Lọc theo thời gian')}
          </label>
          <CustomDateRangePicker
            toggleElementBorderRadius={5}
            alignRight={true}
            initialValue={
              filter.selectedValue?.length > 0
                ? filter.selectedValue
                : dateFilter.baMuoiNgayGanNhat
            }
            onPressSave={(selectedValue, startDate, endDate) => {
              if (onFilterChanged) onFilterChanged({
                from: startDate,
                to: endDate,
                selectedValue: selectedValue,
              });
            }}
            filterComponent={filter}
          />
        </div>

        {/* cau hinh cot */}
        <div className="pr-4 py-2">
          <DropdownTableConfigColumn2
            columnIds={columnIds}
            fullColumns={fullColumns}
            fullColumnIds={fullColumnsIdSorted}
            onChangeCheckboxValue={onChangeCheckboxValue}
            resetDefaultTableColumn={resetDefaultTableColumn}
            onChangeFullColumnIds={(ids) => {
              setFullColumnIds(ids);
              const key = prefKey + '_FULL_COLUMN_IDS';
              localStorage.setItem(key, ids.join('|'));
            }}
            onSelectAll={onSelectAll}
            onUnSelectAll={onUnSelectAll}
          />
        </div>

        <div className="col"></div>
        {/* them bill */}
        {agencyRoleList?.includes(AppConstants.userAgencyType.landlord) && (
          <div className='py-2 mt-2'>
            <KTBSButton
              color={KTBSButtonColor.success}
              title={t('Khai báo tiền điện')}
              size={KTBSButtonSize.default}
              borderRadius={5}
              buttonTitleFontWeight="600"
              iconElement={<i className="fa-regular fa-circle-plus" />}
              additionalClassName="min-w-180px flex-grow-1"
              onPress={handleAddEnergyBill}
            />
          </div>
        )}
      </div>

      {/* body */}
      <div className="mt-4">
        <KTTable
          columns={columns}
          items={items}
          selectableRows={false}
          striped={false}
          compactGrid={false}
          onClickedRow={(row) => {
            // router.navigate(`agency/${row?.agencyId}`);
          }}
          onSelectedRowsChanged={(rows) => { }}
          onDoubleClickedRow={(row) => { }}
          hasActionColumn={user?.role === AppConstants.userRole.admin}
          noDataComponent={
            <EmptyView
              icon={imgEmptyThanhToan}
              title="Không có dữ liệu để hiển thị"
              text={
                <div className="text-center">
                  <span>
                    Hiện không có dữ liệu để hiển thị. Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.
                  </span>
                </div>
              }
            />
          }
        />
      </div>

      {/* phan trang */}
      {!_.isEmpty(items) && (
        <div className="mt-4">
          <KTPagination
            currentPage={filter.page + 1}
            rowCount={pagination?.total}
            rowsPerPage={filter.limit}
            currentItemInPageCount={items?.length}
            onChangePage={(newPage) => {
              const iNewPage = parseInt(newPage);
              if (onFilterChanged) onFilterChanged({ page: iNewPage - 1 });
            }}
            onChangeRowsPerPage={(newRowsPerPage) => {
              const iNewRowsPerPage = parseInt(newRowsPerPage);
              if (onFilterChanged) onFilterChanged({ limit: iNewRowsPerPage, page: 0 });
            }}
            loading={false}
            color={KTPaginationColor.success}
            appendText="hóa đơn"
          />
        </div>
      )}
    </div>
  );
}

export default LandownerElectricityPaymentHistoryView;
